<template>
  <v-container fluid fill-height>
    <v-layout justify-center align-top v-if="init">

      <v-flex text-xs-center v-if="errorMessage === 'unknown'">
        <p style="padding-left: 15px">Произошла неизвестная ошибка, обратитесь к администратору</p>
      </v-flex>

      <v-flex text-xs-center v-if="errorMessage === ''">
          <v-layout row wrap align-center justify-center>
            <v-flex xs12>
              <h1>Страница подтверждения</h1>
            </v-flex>
            <v-flex xs12 sm10 md8 lg7>
              <v-select
                v-model="selectedCompany"
                :items="availableCompanies"
                @change="changeSetup"
                item-text="name"
                item-value="id"
                label="Компания"
                required>
                <template slot='selection' slot-scope='{ item }'>
                  {{ item.id }} - {{ item.name }}
                </template>
                <template slot='item' slot-scope='{ item }'>
                  {{ item.id }} - {{ item.name }}
                </template>
              </v-select>
            </v-flex>

            <v-flex xs12 sm10 md8 lg7 text-xs-left>
              <p style="padding-left: 15px">Нажмите знак вопроса в правом верхнем углу, чтобы увидеть примеры и получить подробную информацию по настройке.</p>
            </v-flex>
            <v-flex xs12 sm10 md8 lg7>
              <v-tabs
                v-model="active"
                slider-color="#4169E1"
                color="#fafafa"
              >
                <v-tab key="1" ripple>
                  Инфо
                </v-tab>
                <v-tab key="2" ripple>
                  Контакты
                </v-tab>
                <v-tab key="3" ripple>
                  Адрес
                </v-tab>
                <v-tab key="4" ripple>
                  Настройка
                </v-tab>

                <v-tab-item key="1">
                  <v-form>
                    <v-flex class="padding5">
                      <v-text-field
                        v-model="selectedSetup.companyNameShort"
                        label="Название компании"
                        hint="Отображается в шапке страницы. Совет: используйте заглавные буквы"
                      ></v-text-field>
                    </v-flex>

                    <v-flex class="padding5">
                      <v-text-field
                        v-model="selectedSetup.confirmationMessage"
                        label="Основной текст"
                        hint="Текст сообщения над фотографией сотрудника"
                      ></v-text-field>
                    </v-flex>

                    <v-flex class="padding5">
                      <v-text-field
                        v-model="selectedSetup.currencyFormat"
                        label="Обозначение валюты"
                        hint="Чтобы между суммой и валютой был пробел, добавьте его в самое начало"
                      ></v-text-field>
                    </v-flex>

                    <v-flex xs12 text-xs-center>
                      <v-btn color="#4169E1" style="color:white" @click="updateInfo()">Сохранить</v-btn>
                    </v-flex>
                  </v-form>
                </v-tab-item>

                <v-tab-item key="2">
                  <v-form ref="features" v-model="valid">
                    <template>
                      <v-text-field
                        v-model="phone"
                        type="number"
                        label="Телефон"
                        hint="Пример: 375291234567"
                      >
                        <template v-slot:prepend>
                          <img width="24" height="24" src="../assets/phone.svg" >
                        </template>
                      </v-text-field>
                      <v-text-field
                        v-model="viber"
                        type="number"
                        label="Viber"
                        hint="Пример: 375291234567"
                      >
                        <template v-slot:prepend>
                          <img style="border-radius:50%;" width="24" height="24" src="../assets/viber.svg" >
                        </template>
                      </v-text-field>
                      <v-text-field
                        v-model="telegram"
                        label="Telegram"
                        hint="Пример: evriday_app. Важно! Вводите никней, но не номер телефона"
                      >
                        <template v-slot:prepend>
                          <img width="24" height="24" src="../assets/telegram.svg" >
                        </template>
                      </v-text-field>
                      <v-text-field
                        v-model="instagram"
                        label="Instagram"
                        hint="Пример: evriday_app"
                      >
                        <template v-slot:prepend>
                          <img width="24" height="24" src="../assets/instagram.svg" >
                        </template>
                      </v-text-field>
                      <v-text-field
                        v-model="vk"
                        label="Вконтакте"
                        hint="Пример: evriday_app"
                      >
                        <template v-slot:prepend>
                          <img width="24" height="24" src="../assets/vk.svg" >
                        </template>
                      </v-text-field>
                    </template>
                    <v-flex xs12>
                      <v-btn color="#4169E1" style="color:white" @click="saveContacts()">Сохранить</v-btn>
                    </v-flex>
                  </v-form>
                </v-tab-item>

                <v-tab-item key="3">
                  <v-form ref="features" v-model="valid">
                    <v-flex class="padding5">
                      <v-text-field
                        v-model="selectedSetup.infoPlace"
                        label="Станция метро"
                        hint="Ближайшая станция метро. Оставьте пустой чтобы не отображать"
                      ></v-text-field>
                    </v-flex>

                    <v-flex class="padding5">
                      <v-text-field
                        v-model="selectedSetup.infoAddressMain"
                        label="Адрес, основная информация"
                      ></v-text-field>
                    </v-flex>

                    <v-flex class="padding5">
                      <v-text-field
                        v-model="selectedSetup.infoAddressAdditional"
                        label="Адрес, дополнительная информация"
                      ></v-text-field>
                    </v-flex>

                    <v-flex xs12>
                      <v-btn color="#4169E1" style="color:white" @click="updateAddress()">Сохранить</v-btn>
                    </v-flex>
                  </v-form>
                </v-tab-item>

                <v-tab-item key="4">
                  <v-form ref="features" v-model="valid">
                    <v-flex>
                      <v-switch
                        color="#4169E1"
                        v-model="showReschedule"
                        label="Перенос записи"
                      ></v-switch>
                    </v-flex>
                    <template v-if="showReschedule">
                      <v-text-field
                        v-model="rescheduleLink"
                        label="Ссылка на перенос записи"
                        hint="Выберите основную ссылку, перейдя в Онлайн-запись -> Веб-сайт. Пример: https://n12345.yclients.com"
                        :rules="linkRules"
                      ></v-text-field>
                    </template>
                    <v-flex xs12>
                      <v-btn color="#4169E1" style="color:white" @click="updateFeatures()">Сохранить</v-btn>
                    </v-flex>
                  </v-form>
                </v-tab-item>
              </v-tabs>
            </v-flex>
          </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from 'axios'

export default {
  data: () => ({
    init: false,
    availableSetups: {},
    selectedSetup: {},
    availableCompanies: [],
    selectedCompany: '',
    errorMessage: '',
    active: null,
    showReschedule: false,
    rescheduleLink: '',
    phone: '',
    viber: '',
    telegram: '',
    instagram: '',
    vk: '',
    valid: true,
    linkRules: [
      v => /https:\/\/.+\.yclients.com\b/.test(v) || 'Ссылка должна быть правильной. Пример: https://n12345.yclients.com'
    ]
  }),
  created () {
    this.$store.commit('showNavigation')
    this.getInfo()
  },
  methods: {
    getInfo: function () {
      axios.get('/api/setupPage/getInfo')
        .then(response => {
          if (response.data.error) {
            this.errorMessage = response.data.message
            if (this.errorMessage !== 'unknown') {
              this.$router.push('/assist')
            }
          } else {
            response.data.forEach(item => {
              this.availableCompanies.push({
                id: item.companyId,
                name: item.companyName
              })
              this.availableSetups[item.companyId] = item
              if (item.isDefault === true) {
                this.selectedSetup = item
              }
            })
            if (this.selectedSetup.companyId === undefined) {
              this.selectedSetup = response.data[0]
            }
            this.selectedCompany = this.selectedSetup.companyId
          }
          this.updateSelects()
          this.init = true
        })
        .catch(error => {
          this.$store.dispatch('handleError', error.response)
        })
    },
    sendData: async function (data) {
      const result = await axios.post('/api/setupPage/update', {
        companyId: this.selectedSetup.companyId,
        data: data
      })
      if (result.status === 200) {
        this.$store.dispatch('showSnackbar', {
          text: 'Настройки обновлены',
          color: 'success'
        })
      } else {
        this.$store.dispatch('showSnackbar', {
          text: 'Во время обновления произошла ошибка',
          color: 'error'
        })
      }
    },
    updateInfo: async function () {
      let data = {}
      data.companyNameShort = this.selectedSetup.companyNameShort
      data.confirmationMessage = this.selectedSetup.confirmationMessage
      data.currencyFormat = this.selectedSetup.currencyFormat
      this.sendData(data)
    },
    saveContacts: async function () {
      let contactButtons = []
      if (this.phone !== '') {
        contactButtons.push({
          btnType: 'call',
          link: this.phone
        })
      }
      if (this.viber !== '') {
        contactButtons.push({
          btnType: 'viber',
          link: this.viber
        })
      }
      if (this.telegram !== '') {
        contactButtons.push({
          btnType: 'telegram',
          link: this.telegram
        })
      }
      if (this.instagram !== '') {
        contactButtons.push({
          btnType: 'instagram',
          link: this.instagram
        })
      }
      if (this.vk !== '') {
        contactButtons.push({
          btnType: 'vk',
          link: this.vk
        })
      }
      this.selectedSetup.contactButtons = contactButtons
      this.updateSelects()
      this.sendData({ contactButtons: contactButtons })
    },
    updateAddress: async function () {
      let data = {}
      data.infoPlace = this.selectedSetup.infoPlace
      data.infoAddressMain = this.selectedSetup.infoAddressMain
      data.infoAddressAdditional = this.selectedSetup.infoAddressAdditional
      this.sendData(data)
    },
    updateFeatures: function () {
      if (this.$refs.features.validate()) {
        if (!this.showReschedule) {
          this.rescheduleLink = ''
        }
        let data = {}
        data.rescheduleLink = this.rescheduleLink
        this.selectedSetup.rescheduleLink = this.rescheduleLink
        this.updateSelects()
        this.sendData(data)
      }
    },
    changeSetup: function (selectedId) {
      this.selectedSetup = this.availableSetups[selectedId]
      this.updateSelects()
    },
    updateSelects: function () {
      this.showReschedule = this.selectedSetup.rescheduleLink !== undefined && this.selectedSetup.rescheduleLink !== ''
      this.rescheduleLink = this.selectedSetup.rescheduleLink
      this.phone = ''
      this.viber = ''
      this.telegram = ''
      this.instagram = ''
      this.vk = ''
      if (this.selectedSetup.contactButtons !== undefined && this.selectedSetup.contactButtons.length > 0) {
        this.selectedSetup.contactButtons.forEach(item => {
          if (item.btnType === 'call') {
            this.phone = item.link
          } else if (item.btnType === 'viber') {
            this.viber = item.link
          } else if (item.btnType === 'telegram') {
            this.telegram = item.link
          } else if (item.btnType === 'instagram') {
            this.instagram = item.link
          } else if (item.btnType === 'vk') {
            this.vk = item.link
          }
        })
      }
    }
  }
}
</script>
